<template>
  <div class="create-order">
    <el-form
      ref="form"
      class="create-order_form"
      :model="form"
      label-position="top"
      :rules="rules"
    >
      <titleBlock
        ref="inventory"
        class="title_bar"
        title="库存校验"
      >
        <div class="text-wrapper">
          <!-- <span class="text1">库存校验</span> -->
          <span class="text2">开启后将校验下单货品库存数量,库存不足将不允许下单</span>
        </div>
        <el-switch
          v-model="form.orderCreateConfig.inventoryCheck"
          :disabled="isDisabled"
          active-color="#059E84"
          class="marginBottom"
          inactive-color="#D9DBDE"
        />
      </titleBlock>
      <titleBlock
        class="title_bar"
        title="仓配一体流程配置"
        alert-info=""
      >
        <el-form-item label="入库流程:" prop="orderCreateConfig.flowConfig.storeType">
          <el-radio-group v-model="form.orderCreateConfig.flowConfig.storeType">
            <el-radio
              v-for="item in STORE_PROCESS_RULE"
              :key="item.value"
              border
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出库流程:" prop="orderCreateConfig.flowConfig.deliverType">
          <el-radio-group v-model="form.orderCreateConfig.flowConfig.deliverType">
            <el-radio
              v-for="item in DELIVERY_PROCESS_RULE"
              :key="item.value"
              border
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </titleBlock>
    </el-form>
    <multiPiecesConfig ref="multiPiecesConfig" @refreshMarkTotal="handleRefreshMarkTotal" />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { processingSelectData } from '@/utils/index';
import ButtonPermission from '@/constant/buttonPermission';
import { mapState } from 'vuex';
import { twoNumberReg } from '@/utils/regExp';
import { getProjectList } from '@/api/user';
import { parentMarkList } from '@/views/shipperSeviceSetting/serveConfig/api';
import titleBlock from '../assembly/titleBlock.vue';
import {
  TIME_UNIT, createOederNav, detailField, markStatus, createOrderTimeoutNotification, STORE_PROCESS_RULE, DELIVERY_PROCESS_RULE,
} from './const';
import multiPiecesConfig from './multiPiecesConfig.vue';

export default {
  components: {
    titleBlock, multiPiecesConfig,
  },
  props: {
    customField: {
      type: Object,
      default: () => { },
    },
    customerCode: {
      type: String,
      default: null,
    },
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validateInsurePrice = (rule, value, callback) => {
      if (value && value !== '') {
        if (!twoNumberReg.test(value)) {
          callback(new Error('保留两位小数(0≤范围≤99999999.99)'));
        }
        const valueArr = (`${value}`).split('.');
        if (Number(valueArr[0] > 99999999)) {
          callback(new Error('整数值最大为99999999'));
        }
        callback();
      }
      callback();
    };

    return {
      validateInsurePrice,
      createOrderTimeoutNotification,
      STORE_PROCESS_RULE,
      DELIVERY_PROCESS_RULE,
      createOederNav,
      detailField,
      active: 1,
      projectOptions: [],
      chooseProjectIds: [], // 选择的运营项目
      rules: {
        'orderCreateConfig.inventoryCheck': [
          { required: true, message: '请选择库存校验', trigger: 'change' },
        ],
        'orderCreateConfig.flowConfig.storeType': [
          { required: true, message: '请选择仓配一体入库流程配置', trigger: 'change' },
        ],
        'orderCreateConfig.flowConfig.deliverType': [
          { required: true, message: '请选择仓配一体出库流程配置', trigger: 'change' },
        ],
      },
      MarkListTotal: 0, // 子母单标识数量
    };
  },
  computed: {
    ...mapState('user', ['buttonsPermission']),
    customFieldOption() {
      return processingSelectData(this.customField);
    },
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    isDisabled() {
      if (this.buttonsPermission && this.buttonsPermission.length) {
        return !this.buttonsPermission.map((item) => item.uri).includes(ButtonPermission.ALLOW_REPLENISH);
      }
      return true;
    },
  },
  watch: {
    customerCode: {
      handler(val) {
        if (val) {
          this.getProjectListFn();
          this.getParentMarkList();
        }
      },
      immediate: true,
    },
    'form.INSURANCE.rules': {
      handler(val) {
        if (!val || !val.length) {
          this.chooseProjectIds = [];
          return;
        }
        this.chooseProjectIds = val.map((t) => t.projectId);
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handelScroll, true);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handelScroll, true);
  },
  methods: {
    async getProjectListFn() {
      const data = await getProjectList({
        customerCodes: [this.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
      })) : [];
    },
    changeIndex(item) {
      this.active = item.index;
      this.$refs[item.ref].scrollIntoView({ block: 'center' });
    },
    changeProject(val, index) {
      const tt = this.form.INSURANCE.rules[index];
      const proItem = this.projectOptions.find((t) => t.value === val);
      this.form.INSURANCE.rules.splice(index, 1, {
        ...tt,
        projectName: proItem.label,
      });
    },
    handleAddInsure() {
      // 添加投保规则
      const list = this.form.INSURANCE.rules;
      list.push({
        projectId: '',
        projectName: '',
        value: '',
      });
      this.$set(this.form.INSURANCE, 'rules', list);
    },
    handleDeleteInsure(index) {
      // 删除投保规则
      const list = this.form.INSURANCE.rules;
      list.splice(index, 1);
      this.$set(this.form.INSURANCE, 'rules', list);
    },
    handelScroll() {
      const { scrollTop } = document.getElementById('popContainer');
      const siteRuleHeight = this.$refs.site.offsetHeight;
      const goodRuleHeight = this.$refs.goods.offsetHeight + siteRuleHeight;
      const timeRuleHeight = this.$refs.order.offsetHeight + goodRuleHeight;
      const prepaymentHeight = this.$refs.prepayment.offsetHeight + timeRuleHeight;
      if (scrollTop > prepaymentHeight) {
        this.active = 5;
      } else if (scrollTop > timeRuleHeight) {
        this.active = 4;
      } else if (scrollTop > goodRuleHeight) {
        this.active = 3;
      } else if (scrollTop > siteRuleHeight) {
        this.active = 2;
      } else {
        this.active = 1;
      }
    },
    async valiForm() {
      await this.$refs.form.validate();
      return {
        form: cloneDeep(this.form),
      };
    },
    clearValidate(prop) {
      this.$refs.form.clearValidate(prop);
    },
    handleConfig() {
      this.$refs.multiPiecesConfig.show(this.customersDetail);
    },
    async getParentMarkList() {
      const { ownerTenantId, customerCode } = this.customersDetail || {};
      const res = await parentMarkList({
        customerCode,
        tenantId: ownerTenantId,
        statuses: [markStatus.ENABLE, markStatus.RECONCILED],
      });
      this.MarkListTotal = res.length || 0;
    },
    handleRefreshMarkTotal() {
      this.getParentMarkList();
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order{
  box-sizing: border-box;
  padding:0 24px 24px;
  padding-bottom: 40px;
  .create-order_form{
  }
  .rule-nav{
    height: 100%;
    position: sticky;
    top: 62px;
    background: #fff;
    width: 200px;
    padding: 24px 0;
    font-size: 12px;
    .nav_item{
      cursor: pointer;
      line-height: 32px;
      position: relative;
      padding: 0 16px;
      color: #323233;
      &::before{
        content:'';
        display: inline-block;
        height: 32px;
        width: 2px;
        background: #fff;
        position: absolute;
        left: 0px;
      }
    }
    .active{
      color: #059E84;
      &::before{
        background-color: #059E84;
      }
    }
  }
  ::v-deep .title_bar{
    border-bottom: 1px solid #D9DBDE;
  }
  .title-block{
    padding-top:24px;
  }
  .marginBottom{
    // margin:8px 0 24px;
    margin:8px 0 12px;
  }
  ::v-deep .el-radio{
    margin-right:8px;
  }
  .text-wrapper{
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
      margin-right: 8px;
    }
    .text2{
      font-size: 13px;
      color:#808792;
      // margin-left:8px;
    }
  }
}
.deliverTime_row{
  padding-top: 8px;
  .form_item_deliverTime{
    .el-form-item__label{
      padding: 0;
    }
    .el-input{
      width: 160px;
      margin-right: 8px;
    }
    .el-select{
      width: 80px;
    }
  }
}
.rule_input{
  ::v-deep.el-form-item__content{
    display: flex;
    align-items: center;
  }
  .el-input{
    width: 45%;
  }
  .rule_sign{
    margin: 0 8px;
    width: 14px;
    height: 1px;
    background: #B3B7BE;
  }
}
.weight_volume_rule_input{
  .el-input{
    width: calc(90% + 30px) ;
  }
}
.el-icon-warning{
  cursor: pointer;
}
.addOrCondition_btn{
  cursor: pointer;
  height: 38px;
  border: 1px dashed #B3B7BE;
  font-size: 14px;
  margin-bottom: 24px;
  .el-icon-plus{
    margin-right: 10px;
  }
  &:hover{
    border-color: #51CDA6;
    color: #51CDA6;
  }
  &:focus{
    border-color: #059366;
    color: #059366;
  }
}
.danger{
  color:red;
  position: relative;
  top:30px;
}
.el-select{
  width: 100%;
}
.tips_text{
  font-size: 14px;
  font-weight: 400;
  margin-left: 12px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
